module.exports = __webpack_public_path__ + "static/0070-872685616b6654239928e3361b7e8b6c.png";